import React from "react";
import { connect } from 'react-redux';
import { Row, Col, Card, CardHeader, CardBody, Badge } from "reactstrap";
import reduxHelper from "./../../../helper/index.js";
import BadgeCard from './BadgeCard.jsx';

class BadgeList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedBadge: null,
      loading: true
    };
    this.helper = new reduxHelper(this.props);
  }

  async componentDidMount() {
    if (this.props.userId) {
      await this.helper.badge().getBadgesByUser(this.props.userId);
    }
    this.setState({ loading: false });
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId && this.props.userId) {
      this.setState({ loading: true });
      await this.helper.badge().getBadgesByUser(this.props.userId);
      this.setState({ loading: false });
    }
  }

  groupBadgesByCategory(badges) {
    var grouped = {};
    badges.forEach(function (badge) {
      var cat = badge.category || 'other';
      if (!grouped[cat]) grouped[cat] = [];
      grouped[cat].push(badge);
    });
    return grouped;
  }

  getCategoryLabel(category) {
    var labels = {
      'course_completion': 'Conclusão de Curso',
      'unit_completion': 'Conclusão de Unidade',
      'quiz_performance': 'Performance em Quiz',
      'time_dedication': 'Dedicação',
      'special': 'Especial'
    };
    return labels[category] || category;
  }

  getCategoryColor(category) {
    var colors = {
      'course_completion': 'danger',
      'unit_completion': 'success',
      'quiz_performance': 'primary',
      'time_dedication': 'info',
      'special': 'warning'
    };
    return colors[category] || 'secondary';
  }

  render() {

    var badges = this.props.badge.badges || [];
    var translate = this.props.translate || {};

    if (this.state.loading) {
      return (
        <Card className="shadow">
          <CardBody className="text-center py-5">
            <i className="fas fa-spinner fa-spin fa-2x text-muted" />
          </CardBody>
        </Card>
      );
    }

    if (badges.length === 0) {
      return (
        <Card className="shadow">
          <CardHeader>
            <h5 className="mb-0"><i className="fas fa-award mr-2" />{translate['badges'] || 'Badges'}</h5>
          </CardHeader>
          <CardBody className="text-center py-4">
            <i className="fas fa-award fa-3x text-muted mb-3" style={{ opacity: 0.3 }} />
            <p className="text-muted">{translate['sem_badges'] || 'Nenhum badge conquistado ainda'}</p>
          </CardBody>
        </Card>
      );
    }

    var grouped = this.groupBadgesByCategory(badges);

    return (
      <Card className="shadow">
        <CardHeader className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0"><i className="fas fa-award mr-2" />{translate['badges'] || 'Badges'}</h5>
          <Badge color="primary" pill>{badges.length}</Badge>
        </CardHeader>
        <CardBody>
          {Object.keys(grouped).map((category) => (
            <div key={category} className="mb-3">
              <Badge color={this.getCategoryColor(category)} className="mb-2">
                {this.getCategoryLabel(category)}
              </Badge>
              <Row>
                {grouped[category].map((badge) => (
                  <Col key={badge.id} xs="6" sm="4" md="3" lg="2" className="mb-2">
                    <BadgeCard
                      badge={badge}
                      size={this.props.size || 'md'}
                      onClick={(b) => this.setState({ selectedBadge: b })}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          ))}
        </CardBody>
      </Card>
    );

  }

}

export default connect(state => ({
  badge: state.badge,
  translate: state.translate,
  user: state.user
}))(BadgeList);
